import * as Sentry from '@sentry/react';
import { logger } from 'utils/logger';

// sagaStack names the failing saga from task metadata rather than JS frames, so it stays
// readable when the trace does not. redux-saga only supplies it when the root task aborts,
// so errors caught inside rootSaga never reach here
export function reportSagaError(error: Error, { sagaStack }: { sagaStack: string }) {
  logger.error(error);

  Sentry.captureException(error, {
    level: 'fatal',
    extra: { sagaStack },
  });
}
